<template>
	<div>
		<!-- PC -->
		<div v-if="ifPc == 1" style="width: 100%;">
			<div style="height: 100px;background-color: white;position: fixed;width: 100%;z-index:100;">

				<div style="padding:20px 60px;">
					<div @click="gotoHome" style="display: inline-block;cursor: pointer;">
						<div style="display: inline-block;height: 60px;vertical-align: top;">
							<div style="height: 60px;display: grid;align-items: center;">
								<el-image src="/newImage/logo.png"
									style="height: 48px;display: inline-block;width: 141.29px;" />
							</div>
						</div>
						<div
							style="display: inline-block;height: 60px;vertical-align: top;border-left: 1px solid black;margin-left: 38px;margin-right: 38px;">

						</div>
						<div style="display: inline-block;height: 60px;vertical-align: top;">
							<div style="display: grid;align-items: center;height: 60px;font-size: 24px;">
								For Better Business, Always
							</div>
						</div>
					</div>

					<div @click="gotoContact"
						style="display: inline-block;height: 60px;float: right;cursor: pointer;font-size: 24px;line-height: 60px;">
						<div :style="'font-weight:'+(pageName == 'Contact'?'bold;':'400;')">CONTACT</div>
					</div>
					<div @click="gotoAboutus"
						style="display: inline-block;height: 60px;float: right;cursor: pointer;font-size: 24px;line-height: 60px;margin-right: 38px;">
						<div :style="'font-weight:'+(pageName == 'AboutUs'?'bold;':'400;')">ABOUT US</div>
					</div>
				</div>


			</div>
			<div style="height: 100px;"></div>
		</div>


		<!-- 手机 -->
		<div v-if="ifPc == 2">
			<div style="height: 23px;background-color: white;position: fixed;width: 100%;z-index:100;">

				<div style="padding:5px 14px;">
					<div @click="gotoHome" style="display: inline-block;cursor: pointer;">
						<div style="display: inline-block;height: 14px;vertical-align: top;">
							<div style="height: 14px;display: grid;align-items: center;">
								<el-image src="/newImage/logo.png"
									style="height: 11px;display: inline-block;width:32.28px;" />
							</div>
						</div>
						<div
							style="display: inline-block;height: 14px;vertical-align: top;width: 1px;transform: scaleX(0.23);background-color: black; margin-left: 10px;margin-right: 10px;">

						</div>
						<div style="display: inline-block;height: 14px;vertical-align: top;">
							<div style="height: 14px;font-size: 8px;line-height: 14px;">
								For Better Business, Always
							</div>
						</div>
					</div>

					<div @click="gotoContact"
						style="display: inline-block;height: 14px;float: right;cursor: pointer;font-size: 8px;line-height: 14px;">
						<div :style="'font-weight:'+(pageName == 'Contact'?'bold;':'400;')">CONTACT</div>
					</div>
					<div @click="gotoAboutus"
						style="display: inline-block;height: 14px;float: right;cursor: pointer;font-size: 8px;line-height: 14px;margin-right: 14px;">
						<div :style="'font-weight:'+(pageName == 'AboutUs'?'bold;':'400;')">ABOUT US</div>
					</div>
				</div>


			</div>
			<div style="height: 23px;"></div>
		</div>

		<div v-show="ifShow"></div>
		<router-view style="background-color: white;" :key="$route.path + $route.query.t" />

		<div v-if="ifPc == 1">
			<div style="background-color: black;color:white;padding-top: 100px;">
				<div style="margin:0px 60px 0px 100px;">
					<div style="display:flex;align-items: center;">
						<div style="height: 68px;display: grid;align-items: center;">
							<el-image src="/newImage/logo.png"
								style="height: 67.94px;display: inline-block;width: 200px;" />
						</div>
						<div style="font-size: 20px;line-height: 30px;margin-left: 60px;flex:1;">
							Formed as a Texas corporation in 2015, Joblogic-X is a fast-growing services company that
							specializes in marketing solutions, trade services and staffing/consulting.
						</div>
					</div>
					<div style="margin-top: 120px;">
						<div style="font-size: 24px;font-weight: bold;">
							Our Offices
						</div>
						<div style="font-size: 20px;margin-top: 10px;">
							5813 Wilford Dr, Mckinney, TX 75070
						</div>
						<div style="font-size: 20px;margin-top: 10px;">
							2001 Coit Rd #137, Plano, TX 75075
						</div>


						<div style="font-size: 24px;font-weight: bold;margin-top: 60px;">
							Phone
						</div>
						<div style="font-size: 20px;margin-top: 10px;">
							800-571-6066
						</div>

						<div style="font-size: 24px;font-weight: bold;margin-top: 60px;">
							Email
						</div>
						<div style="font-size: 20px;margin-top: 10px;">
							Info@joblogic-x.com
						</div>
					</div>
				</div>
				<div style="height: 60px;border-bottom: 1px solid white;margin-left: 60px;margin-right: 100px;"></div>
				<div
					style="text-align: right;font-size: 20px;margin-top: 30px;margin-right: 100px;padding-bottom: 60px;">
					©2026 Joblogic-X. All rights reserved.
				</div>
			</div>
		</div>

		<div v-if="ifPc == 2">
			<div style="background-color: black;color:white;padding-top: 23px;">
				<div style="margin: 0px 23px 0px 23px;">
					<div style="display:flex;align-items: center;">

						<div style="height: 16px;display: grid;align-items: center;">
							<el-image src="/newImage/logo.png" style="height: 15.57px;width: 45.83px;" />
						</div>
						<div style="flex:1;font-size: 6px;line-height: 8px;margin-left: 10px;">
							Formed as a Texas corporation in 2015, Joblogic-X is a fast-growing services company that
							specializes in marketing solutions, trade services and staffing/consulting.
						</div>

					</div>
					<div style="margin-top: 15px;">
						<div style="font-size: 6px;font-weight: bold;">
							Our Offices
						</div>
						<div style="font-size: 6px;line-height: 8px;">
							5813 Wilford Dr, Mckinney, TX 75070
						</div>
						<div style="font-size: 6px;line-height: 8px;">
							2001 Coit Rd #137, Plano, TX 75075
						</div>


						<div style="font-size: 6px;font-weight: bold;margin-top: 10px;">
							Phone
						</div>
						<div style="font-size: 6px;line-height: 8px;">
							800-571-6066
						</div>

						<div style="font-size: 6px;font-weight: bold;margin-top: 10px;">
							Email
						</div>
						<div style="font-size: 6px;line-height: 8px;">
							Info@joblogic-x.com
						</div>
					</div>
				</div>
				<div
					style="transform: scaleY(0.23);margin-top: 15px;height:1px;background-color: white;margin-right: 23px;margin-left: 14px;">
				</div>
				<div style="text-align: right;font-size: 6px;margin-top: 10px;padding-bottom: 23px;margin-right: 23px;">
					©2026 Joblogic-X. All rights reserved.
				</div>
			</div>
		</div>

	</div>
</template>
<script>
	export default {
		name: 'App',
		data() {
			return {
				fullPath: "",
				menus: [],
				showMenu: false,
				ifPc: window.innerWidth > window.innerHeight ? 1 : 2, // 默认根据宽高判断 1PC 2手机
				pageName: null,
				scrollHeight: 0,
			}
		},
		computed: {
			ifShow() {
				this.pageName = this.$route.name;
				return true;
			}
		},
		methods: {
			goTo(url) {
				this.showMenu = false;
				this.$router.push(url);
			},
			gotoHome() {
				this.$router.push({
					path: '/'
				});
			},
			gotoAboutus() {
				this.$router.push({
					path: '/AboutUs'
				});
			},

			gotoContact() {
				this.$router.push('/Contact');
			},
			handleScroll() {
				this.scrollHeight = window.scrollY;
			},
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
		}

	}
</script>

<style lang="less">
	/* 全局字体设置 */
	:root {
		--font-family-base: Arial, sans-serif;
	}


	* {
		margin: 0px;
		padding: 0px;
	}

	body,
	html {
		height: 100%;
		font-family: var(--font-family-base);
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	/* 确保所有元素继承字体 */
	* {
		font-family: inherit;
	}
</style>